<template>
	<div class="customer-reviews">
		<div class="row">
			<div class="col col-12" v-if="!isLoading && show">
				<b>Bewertungen vom Abo-Anbieter</b>
				<div class="rating-stars">
					<star-rating read-only :increment="0.1" :fixed-points="2" :padding="1" :show-rating="false" :rating="rating" inactive-color="#DBDBDB" active-color="#ffc100" :star-size="18"></star-rating>
					<small>({{ ratingAmount }} Bewertungen)</small>
				</div>
				<small>{{ ratingText }} {{ rating }} von 5 Sternen</small>
			</div>
			<div class="col col-12" v-if="isLoading">
				<small>Lädt Bewertungen..</small>
			</div>
		</div>
	</div>
</template>

<script>
import StarRating from 'vue-star-rating'

export default {
	name: "CustomerReviews",
    components: {
        StarRating
    },
	props:['ratingCount', 'ratingAverage'],
	data() {
		return {
			data: {
				rating: this.ratingAverage,
				ratingAmount: this.ratingCount
			},
			isLoading: true
		}
	},
	methods: {
		getRatings() {
			this.isLoading = false
		}
	},
	computed: {
		rating() {
			return this.data.rating;
		},
		ratingText() {
			if (this.data.rating >= 4) {
				return "Sehr gut, mit"
			} else if (this.data.rating <= 3.9 && this.data.rating >= 2.6) {
				return "Gut, mit"
			} else if (this.data.rating <= 2.5) {
				return "Bewertet mit"
			} 
		},
		ratingAmount() {
			return this.data.ratingAmount;
		},
		show() {
			return this.data.ratingAmount >= 3
		}
	},
	mounted() {
		this.getRatings()
	}
}
</script>

<style scoped>

</style>
